// Double-submit guard for forms that opt out of Turbo.
//
// Turbo already disables the submitter and sets aria-busy on every form it
// handles (its default config is `submitter: "disabled"`), so forms driven by
// Turbo need nothing. Forms carrying data-turbo="false" submit natively and
// get neither, which lets a second click create a duplicate record — the
// create-a-class form is one of them.

const GUARDED = "data-submit-guard-disabled"

document.addEventListener("submit", (event) => {
  const form = event.target
  if (!(form instanceof HTMLFormElement)) return
  if (form.dataset.turbo !== "false") return
  if (event.defaultPrevented) return

  const submitter = event.submitter
  if (!submitter || submitter.disabled) return

  // Defer past form serialisation: disabling a submitter synchronously drops
  // its name/value from the payload.
  requestAnimationFrame(() => {
    submitter.disabled = true
    submitter.setAttribute(GUARDED, "")
    form.setAttribute("aria-busy", "true")

    const busy = submitter.dataset.submitsWith
    if (busy) {
      if (submitter.tagName === "INPUT") {
        submitter.dataset.originalValue = submitter.value
        submitter.value = busy
      } else {
        submitter.dataset.originalValue = submitter.innerHTML
        submitter.textContent = busy
      }
    }
  })
})

// Restore on bfcache/back-navigation so the button isn't left dead.
const release = () => {
  document.querySelectorAll(`[${GUARDED}]`).forEach((submitter) => {
    submitter.disabled = false
    submitter.removeAttribute(GUARDED)

    const original = submitter.dataset.originalValue
    if (original !== undefined) {
      if (submitter.tagName === "INPUT") submitter.value = original
      else submitter.innerHTML = original
      delete submitter.dataset.originalValue
    }

    submitter.form?.removeAttribute("aria-busy")
  })
}

window.addEventListener("pageshow", release)
document.addEventListener("turbo:load", release)
